/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { useLocation, matchPath, Outlet, useNavigate } from "react-router-dom";
import { useResizeContext } from "datastake-daf/dist/context";


// import Dashboard from "./screens/dashboard/index";
import { actions } from '../../store/reducers/authentication';
import { actions as projectActions } from '../../store/reducers/project';
import Sidenav from "../Sidenav";
import { hasModule } from "../../constants/user";
import { Layout, Select, Typography } from 'antd';
import {
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import privateRoutes from "../../routes/privateRoutes";
import { filterSelectOptions } from 'datastake-daf/src/helpers/Forms';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { getProject } from "../../services/BaseService";
import { NOTIFICATION_MODE, useForms } from "../../context/Forms";
import { UserDropdownMenu } from "./components/UserDropdown";
import Notifications from "./components/Notifications";
import { NotificationsProvider } from "../Notifications/context";
import { NotificationsHistoryProvider } from "../Notifications/components/NotificationHistory/context";
import { usePermissions } from "../../permissions/usePermissions";
import { getSourceName, supportedModules, useApp } from "../../helpers/user";
import { useGetSources } from "../../helpers/Sources";
import { UserService } from "../../services";
import MobileDrawer from "./components/MobileDrawer";

const { Content } = Layout;

function AppLayout({
  authentication: { user, selectedProject, sourceId },
  project: { data: { projects } },
  module,
  logout,
  exitImpersonation,
  updateLanguage,
  ProjectsGet,
  getUserOptions,
  changeSelectedProject,
  changeSelectedProjectAndSourceId,
  changeSourceId,
  disabledSelects = false,
  onCollapse = () => { },
  children,
}) {
  const setSourceId = (val) => changeSourceId(val);
  const { notificationMode, changeNotificationState } = useForms();

  const [projectData, setProjectData] = useState(null);

  const settingRoutes = useMemo(() => (privateRoutes || []).reduce((a, b) => {
    if (b.setting) {
      a.push(b.path);
    } else if (b.routes) {
      b.routes.forEach(r => {
        if (r.setting) {
          a.push(r.path);
        }
      })
    }
    return a;
  }, []), []);

  const hideSourceRoutes = (privateRoutes || []).reduce((a, b) => {
    if (b.hideSource) {
      a.push(b.path);
    } else if (b.routes) {
      b.routes.forEach(r => {
        if (r.hideSource) {
          a.push(r.path);
        }
      })
    }
    return a;
  }, []);
  const { t } = useTranslation();
  const [userPreferences, setUserPreferences] = useState(null);
  const goTo = useNavigate();
  const isAppNavigation = module === 'app';
  const { pathname } = useLocation();
  const [drawerOpened, setDrawerOpened] = useState(false);
  const [settingsDrawerOpened, setSettingsDrawerOpened] = useState(false);
  const canAccessModule = hasModule(user, module);
  const { isCollapsed, setIsCollapsed } = useResizeContext();
  const [projectDropdown, setProjectDropDown] = useState([]);
  const { sources } = useGetSources({ projectData });
  const [sProject, setSelectedProject] = useState(selectedProject);
  const [hasPrevious, setPrevious] = useState(false);
  const unApprovedProjects = useMemo(() => (
    user && user.projects && user.projects.length ? user.projects.filter(p => p.status === 'pending') : []
  ), [user, projects]);
  const approvedUserProjectIds = useMemo(() => (
    user && user.projects && user.projects.length ? user.projects.filter(p => p.status === 'approved').map(p => p.projectId) : []
  ), [user, projects]);
  const [hasNotifications, setHasNotifications] = useState(unApprovedProjects.length ? true : false);
  const app = useApp();
  const canViewNotifications = usePermissions({ permission: 'notifications.canView' }) && !isAppNavigation

  useEffect(() => {
    const _fetchPreferences = async () => {
      try {
        const { data } = await UserService.getUserPreference();
        setUserPreferences(data)
      } catch (err) {
        console.log(err)
      }
    }

    _fetchPreferences();
  }, []);

  const _sources = useMemo(() => {
    // workaround
    if (sources.length > 9) {
      return [...sources, {
        label: '',
        authorId: 'workAround',
      }];
    }

    return sources;
  }, [sources]);

  const setIsCollapse = (val = false) => {
    localStorage.setItem('is_collapsed', val ? 'true' : 'false');
    setIsCollapsed(val);
  };

  const logOut = () => {
    sessionStorage.removeItem('notifications');
    if (hasPrevious) {
      exitImpersonation();
      return;
    }
    logout();
  }

  const HIDE_SOURCE_DROPDOWN = !!hideSourceRoutes.filter(path => matchPath({ path: path }, pathname) ? true : false).length;
  const infoSourceIsShown = useMemo(() =>
    (selectedProject !== 'myOwnData' && user?.modules.pme) && module === 'pme' && projectData
      && Array.isArray(projectData.sources) && projectData.sources.length && !HIDE_SOURCE_DROPDOWN
      ? true : false
    , [selectedProject, user, projectData, HIDE_SOURCE_DROPDOWN]);

  useEffect(() => {
    if (selectedProject === 'myOwnData') {
      localStorage.removeItem('source');
      if (user && user?.company?.id) {
        setSourceId(user?.company?.id);
      }
    } else {
      if (sourceId) {
        localStorage.setItem('source', sourceId);
      }
    }
  }, [selectedProject]);


  useEffect(() => {
    if (
      infoSourceIsShown &&
      !sourceId &&
      (projectData && projectData.sources)
    ) {
      const sources = projectData.sources.map(s => s.authorId);
      if (sources.length) {
        // TO-SEE
        const sId = 'overview';
        if (!localStorage.getItem('source') || ![user?.company?.id].concat(sources).includes(localStorage.getItem('source'))) {
          if (sId) {
            setSourceId(sId);
            localStorage.setItem('source', sId);
          }
        }
        return;
      }
    }
  }, [user.language, sourceId, selectedProject]);

  useEffect(() => {
    if (projects && projects.length && selectedProject) {
      const pData = projects.find(p => p.id === selectedProject);
      setProjectData(pData);
      if (projectData && projectData.id !== selectedProject && pData) {
        // TO-SEE
        // const sources = pData.sources.map(s => s.authorId);
        setSourceId('overview');
        // TO-SEE
        localStorage.setItem('source', 'overview');
      }
    }
  }, [projects, selectedProject]);

  const IS_SEETTING_PAGE = useMemo(() =>
    settingRoutes.filter(path => matchPath({ path: path }, pathname) ? true : false).length > 0, [pathname]);

  const isUserApproved = user?.modules && user?.modules[module] && user?.modules[module].status === 'approved' ? true : false;

  useEffect(() => {
    if (localStorage.getItem('previous')) {
      setPrevious(true);
    }
    if (!['tif', 'tazama'].includes(module)) {
      ProjectsGet({ namespace: 'PMEProject', module, view: 'project' });
    }
  }, [user.language]);

  useEffect(() => {
    getUserOptions(user.language);
  }, [user.language]);

  useEffect(() => {
    setHasNotifications(unApprovedProjects.length ? true : false);
  }, [unApprovedProjects])

  useEffect(() => {
    if (projects && supportedModules.includes(module)) {
      const activeProjects = projects.filter(p => approvedUserProjectIds.includes(p.id)).map(p => {
        return {
          id: p.id,
          name: p.name
        };
      }).filter((p, index, self) => index === self.findIndex(s => s.id === p.id));

      let storageProjectId = getProject();
      if (!activeProjects.find(p => p.id === storageProjectId)) {
        storageProjectId = 'myOwnData';
        localStorage.setItem('project', storageProjectId);
        setSelectedProject(IS_SEETTING_PAGE ? 'setting' : storageProjectId);
      }
      const up = [];
      if (IS_SEETTING_PAGE) {
        up.push({ id: 'setting', name: t('Settings') })
      }
      if (isUserApproved) {
        up.push({ id: 'myOwnData', name: t('Navbar::Own Data') });
      }
      const dP = [
        {
          id: 'user',
          name: t('User'),
          items: up
        }];
      if (activeProjects.length) {
        // workaround
        const allLength = up.length + activeProjects.length
        dP.push({
          id: 'projects',
          name: t('Projects'),
          items: allLength > 8 ? [...activeProjects, { label: '', id: 'workAround' }] : activeProjects
        });
      }

      setProjectDropDown([
        ...dP
      ]);
    }
  }, [projects, IS_SEETTING_PAGE, t])

  useEffect(() => {
    if (IS_SEETTING_PAGE) {
      setSelectedProject('setting');
      localStorage.setItem('project', 'myOwnData');
      changeSelectedProject('myOwnData');
    } else {
      if (!selectedProject) {
        if (getProject()) {
          setSelectedProject(getProject());
          changeSelectedProject(getProject());
        } else {
          setSelectedProject('myOwnData');
          localStorage.setItem('project', 'myOwnData');
          changeSelectedProject('myOwnData');
        }
      } else {
        setSelectedProject(selectedProject);
      }
    }
  }, [selectedProject, IS_SEETTING_PAGE])

  const onChangeProject = (id) => {
    const p = projects.find(pr => pr.id === id);
    let projectId = id;
    if (p) {
      localStorage.setItem('project', p.id)
      changeSelectedProject(p.id, p.dashboardView);
      projectId = p.id;
      goTo(`/app/${module}`);
    } else {
      if (id === 'myOwnData') {
        localStorage.removeItem('source');
        changeSelectedProjectAndSourceId(id, user?.company?.id, undefined);
      }
      localStorage.setItem('project', id)
      changeSelectedProject(id, undefined);
      goTo(`/app/${module}`);
    }
    if (sProject === 'setting') {
      goTo(`/app/${module}`);
    }
    setSelectedProject(projectId)

    if (projectId !== 'myOwnData') {
      changeSourceId('overview');
    }
  }

  const collapsedAppLogo = useMemo(() => {
    switch (app) {
      case 'tif':
        return '/assets/images/tif-logo-small.svg';
      case 'tazama':
        return '/assets/images/tazama-logo-small.svg';
      default:
        return '/assets/images/logo-new-white-icon.svg';
    }
  }, [app]);

  const appLogo = useMemo(() => {
    if (isCollapsed) {
      return collapsedAppLogo;
    }

    switch (app) {
      case 'tif':
        return '/assets/images/tif-logo.svg';
      case 'tazama':
        return '/assets/images/tazama-logo-nav.svg';
      default:
        return '/assets/images/logo-new-white.svg';
    }
  }, [app, isCollapsed, collapsedAppLogo]);

  const showProjectDropdown = projectDropdown.length && app === 'mmt';

  const toggleSettingsDrawer = () => {
    if (!settingsDrawerOpened) {
      setDrawerOpened(false);
      setSettingsDrawerOpened(true);
      return;
    }

    setSettingsDrawerOpened(false);
  }

  const toggleDrawer = () => {
    if (!drawerOpened) {
      setSettingsDrawerOpened(false);
      setDrawerOpened(true);
      return;
    }

    setDrawerOpened(false);
  }

  return <div style={{ display: 'flex', flexDirection: 'row', width: '100vw', height: '100dvh', maxHeight: '100dvh' }} className="components-layout">
    {!isAppNavigation ? (
      <div
        className={formatClassname([isCollapsed ? 'sidenav-sider-collapsed sidenav-sider desktop-sider' : 'sidenav-sider sidenav-sider-opened desktop-sider', app])}
        style={{ width: isCollapsed ? '70px' : '250px', minWidth: isCollapsed ? 'auto' : '250px' }}>
        <div className="logo">
          <img
            src={appLogo}
            onClick={() => {
              if (Object.keys(user?.modules || {}).length <= 1) {
                return;
              }

              if (notificationMode === NOTIFICATION_MODE.PROJECT_SOURCES) {
                changeNotificationState({ onYes: () => goTo('/app') });
              } else {
                goTo('/app');
              }
            }}
            alt="img"
            className={app}
          />
        </div>
        {canAccessModule && <Sidenav showMenu module={module} isCollapsed={isCollapsed} />}
      </div>
    ) : null}

    <div style={{ width: '100%', minHeight: '100dvh' }}>
      <header style={{
        padding: 0,
      }}
        className={formatClassname(
          [
            "site-layout-sub-header-background text-white d-flex justify-content-between",
            !isCollapsed && 'header-collapsed',
            'layout-header',
            app
          ]
        )}
      >
        <div className="d-flex left-sidebar right-sidebar">
          <div className="desktop">
            {isAppNavigation ? null : React.createElement(isCollapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger',
              onClick: () => {
                setIsCollapse(!isCollapsed);
                onCollapse(!isCollapsed);
              },
            })}
            {showProjectDropdown ? <Select
              style={{
                color: 'white',
                height: '30px',
                margin: 'auto 0px auto 10px',
                minWidth: '300px',
                maxWidth: '300px',
                paddingTop: 3,
                paddingBottom: 3,
              }}
              // showSearch={true}
              filterOption={filterSelectOptions}
              optionFilterProp="children"
              className="ln-22 dark-select"
              popupClassName={formatClassname(['dark-select-popup', app])}
              defaultValue={sProject}
              value={sProject}
              bordered={false}
              disabled={disabledSelects}
              onChange={id => {
                if (notificationMode === NOTIFICATION_MODE.PROJECT_SOURCES) {
                  changeNotificationState({ onYes: () => onChangeProject(id) });
                } else {
                  onChangeProject(id);
                }
              }}>
              {projectDropdown.map(p => {
                return <Select.OptGroup label={p.name} key={p.id}>
                  {p.items && p.items.length ? p.items.map(pr => {
                    return <Select.Option key={pr.id} value={pr.id}>
                      <Typography.Text ellipsis={{ tooltip: pr.name }}>
                        {pr.name}
                      </Typography.Text>
                    </Select.Option>
                  }) : null}
                </Select.OptGroup>
              })}
            </Select>
              : null}
            {infoSourceIsShown && (
              <Select
                style={{
                  color: 'white',
                  height: '30px',
                  margin: 'auto 0px auto 10px',
                  minWidth: '300px',
                  maxWidth: '300px',
                  paddingTop: 3,
                  paddingBottom: 3,
                }}
                disabled={disabledSelects}
                // showSearch={true}
                optionFilterProp="children"
                className="ln-22 dark-select"
                popupClassName={formatClassname(['dark-select-popup', app])}
                bordered={false}
                value={sourceId}
                onChange={sourceId => {
                  if (sourceId) {
                    localStorage.setItem('source', sourceId);
                    setSourceId(sourceId);
                  }
                }}
              >
                <Select.Option value="overview">
                  <Typography.Text ellipsis={{ tooltip: t('Overview') }}>
                    {t('Overview')}
                  </Typography.Text>
                </Select.Option>
                {_sources.map((source, i) => (
                  <Select.Option key={i} value={source.authorId}>
                    <Typography.Text ellipsis={{ tooltip: getSourceName(source) }}>
                      {getSourceName(source)}
                    </Typography.Text>
                  </Select.Option>
                ))}
              </Select>
            )}
          </div>
          <div className="mobile" onClick={toggleDrawer}>
            <img src={collapsedAppLogo} alt="mmt-logo" />
          </div>
          <div className="mobile cursor-pointer pl-0" onClick={toggleDrawer}>
            {module !== 'app' ? (
              <MenuOutlined className="mobile-burger" />
            ) : null}
          </div>
        </div>
        <div className="d-flex right-sidebar">
          {canViewNotifications ? (
            <NotificationsProvider>
              <NotificationsHistoryProvider>
                <Notifications
                  userPreferences={userPreferences}
                  module={module}
                  hasNotifications={hasNotifications}
                  isUserApproved={isUserApproved}
                  projects={projects}
                  unApprovedProjects={unApprovedProjects}
                />
              </NotificationsHistoryProvider>
            </NotificationsProvider>
          ) : <div className="notification-icon" />}
          <div className="flex flex-column">
            {/* <span>{t("Language")}</span> */}
            <Select
              className="ln-22 dark-select language-select"
              style={{ color: 'white', height: '30px' }}
              defaultValue={localStorage.getItem('datastakeLng') || 'en'}
              bordered={false}
              onChange={lng => updateLanguage(lng)}
              popupClassName={formatClassname(['dark-select-popup language-select', app])}
            >
              <Select.Option value="en">
                <div className="row-cont flex">
                  <div className="cont mr-2">
                    <img src="/assets/images/countries/gb.png" alt="img" style={{ width: 20, height: 12 }} />
                  </div>
                  <div className="cont">
                    EN
                  </div>
                </div>
              </Select.Option>
              <Select.Option value="fr">
                <div className="row-cont flex">
                  <div className="cont mr-2">
                    <img src="/assets/images/countries/fr.png" alt="img" style={{ width: 20, height: 12 }} />
                  </div>
                  <div className="cont">
                    FR
                  </div>
                </div>
              </Select.Option>
            </Select>
          </div>
          <div className="user-details d-flex">
            <UserDropdownMenu
              module={module}
              user={user}
              toggleSettingsDrawer={toggleSettingsDrawer}
              settingsDrawerOpened={settingsDrawerOpened}
              notificationMode={notificationMode}
              isAppNavigation={isAppNavigation}
              goTo={goTo}
              changeNotificationState={changeNotificationState}
              isUserApproved={isUserApproved}
              t={t}
              logOut={logOut}
            />
          </div>
        </div>
      </header>
      <Content className={formatClassname(["bg-white", "layout-children"])}>
        <div className={`${canAccessModule ? "container" : "w-100 h-100"} bg-white`}>
          {!!children ? children : <Outlet />}
        </div>
      </Content>
      {module !== 'app' ? (
        <MobileDrawer mod={module} toggle={toggleDrawer} drawerOpened={drawerOpened} />
      ) : null}
      {/* <Footer style={{ textAlign: 'center' }}>&copy;  Datastake {moment().format('YYYY')}</Footer> */}
    </div>
  </div >

}
export default connect(({ cadd, authentication, project }) => ({
  cadd: {
    ...cadd
  },
  authentication: {
    ...authentication
  },
  project: {
    ...project
  },
}), { ...actions, ...projectActions })(AppLayout);
